import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import '@swc/helpers';

const ImplicitAccountCreationContainer = ()=>{
    const { account  } = useCheckoutSettings();
    const { getFormattedLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            implicitAccountCreation: getFormattedLabel('checkout.createAccount.agreement', {
                parseLink: true,
                openLinksInNewTab: true
            })
        })
    , [
        getFormattedLabel
    ]);
    if (!(account === null || account === void 0 ? void 0 : account.implicitAccountCreation)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Text, {
        className: "checkout-step__disclaimer"
    }, labels.implicitAccountCreation);
};

export { ImplicitAccountCreationContainer };
//# sourceMappingURL=ImplicitAccountCreationContainer.js.map
